import {CALCULATION_TYPE_VALUES, IF_CARD, IF_SCHEME_ROLE_ID_APPLICABLE_TO_MAPPING, IF_SUB_SCHEME_DETAIL_CONFIG, IF_SUB_SCHEMES} from "../../../config/constant"
const handleIfAddIncentive = (value, incentiveName,schemeList,incentive_list,incentive_scheme_selected, schemeRoleId) => { 
    let parent_name = incentiveName;    
    if (incentive_list[value]) {
        incentive_list[value].forEach((el) => {
            if (el.parent_name) {
                parent_name = el.parent_name;
            }
        })
    }
    

    let switch_value = value ? value : incentive_scheme_selected;
    let currentIncentiveCount = (incentive_list[switch_value]) ? incentive_list[switch_value].length : 0;
    let formConfig = (schemeList) ? schemeList.filter(ob => Number(ob.id) === Number(switch_value)) : [];
    
    let incentive_data = {
        product_type: "Inventory Funding",
        scheme_duration: new Date().getUTCMonth() + 1,
        applicable_to: schemeRoleId ? IF_SCHEME_ROLE_ID_APPLICABLE_TO_MAPPING[schemeRoleId] : "",
        description: "",
        is_deleted: 0,
        is_expired: 0,
        scheme_type_id: switch_value,
        status: 1,
        parent_name: parent_name,
        temp_id: switch_value + '_' + currentIncentiveCount,
        form_config: (formConfig.length) ? formConfig[0].form_config : {}
    };
    incentive_data[incentive_data.form_config.KEY] = [IF_CARD[incentive_data.form_config.KEY]];
    switch_value = switch_value.toString();

   
    switch (true) {
        case (incentive_data.form_config.hasOwnProperty('AUM_EXIT')):
            incentive_data['calculation_type'] = CALCULATION_TYPE_VALUES.PERCENTAGE;
            break;
        case (incentive_data.form_config.hasOwnProperty('FRESH_GMV')):
            incentive_data['calculation_type'] = CALCULATION_TYPE_VALUES.FLAT;
            incentive_data["sub_schemes"] = [
                {
                    sub_scheme_type_id: IF_SUB_SCHEMES.MAPPED_DEALER,
                    first_reduction: false,
                    sub_scheme_details: [{ ...IF_SUB_SCHEME_DETAIL_CONFIG }],
                },
                {
                    sub_scheme_type_id: IF_SUB_SCHEMES.MIN_GMV,
                    first_reduction: true,
                    sub_scheme_details: [{ ...IF_SUB_SCHEME_DETAIL_CONFIG }],
                },
            ];
            break; 
        case (incentive_data.form_config.hasOwnProperty('ACTIVATION')):
            incentive_data["threshold_gmv"] = "";
            incentive_data["dealer_remaining_limit"] = "";
            incentive_data["sub_schemes"] = [
                {
                    sub_scheme_type_id: IF_SUB_SCHEMES.MAPPED_DEALER,
                    first_reduction: true,
                    sub_scheme_details: [{ ...IF_SUB_SCHEME_DETAIL_CONFIG }],
                },
            ];
            break; 
        case (incentive_data.form_config.hasOwnProperty('NCL')):
            incentive_data['ageing_days'] = "";
            break; 
        default:
            break;
       
    }
    if (incentive_list[parseInt(switch_value)]) {
        incentive_list[parseInt(switch_value)].push(incentive_data);
    } else {
        incentive_list[parseInt(switch_value)] = [];
        incentive_list[parseInt(switch_value)].push(incentive_data);
    }
    return {incentive_list, incentive_scheme_selected};

};
export default handleIfAddIncentive;